export const roadmappingQueryKeys = {
  roadmap: {
    list: () => ['roadmap', 'list'] as const,
    details: (roadmapId: number) => ['roadmap', roadmapId] as const,
    allUsersPermissions: (roadmapId: number) =>
      ['roadmap', roadmapId, 'allUsersPermissions'] as const,
    owner: (roadmapId: number) => ['roadmap', roadmapId, 'owner'] as const,
    userPermissions: (roadmapId: number) => ['roadmap', roadmapId, 'userPermissions'] as const,
  },
  admin: {
    ownedRoadmapsCount: (userId: string) =>
      ['roadmap', 'admin', userId, 'ownedRoadmapsCount'] as const,
  },
  items: {
    partial: () => ['roadmap', 'items'] as const,
    list: ({ filterKey }: { filterKey?: string } = {}) =>
      ['roadmap', 'items', { filterKey }] as const,
  },
  roadmapItem: {
    detail: (roadmapId: number, itemId: number) => ['roadmap', roadmapId, 'item', itemId] as const,
  },
  itemsViewLayout: {
    detail: (roadmapId: number) => ['roadmap', roadmapId, 'items', 'layout'] as const,
  },
  roadmapViewItems: {
    /** Partial key to invalidate all view items for a roadmap */
    partial: (viewId: number) => ['view', viewId] as const,
    partialViewItems: (viewId: number) => ['view', viewId, 'items'] as const,
    detail: (viewId: number, visualizationId?: number) =>
      visualizationId === undefined
        ? (['view', viewId, 'items'] as const)
        : (['view', viewId, 'items', { visualizationId }] as const),
    treeSet: (viewId: number, filterKey?: string) =>
      ['view', viewId, 'items', 'tree-set', { filterKey }] as const,
  },
  snapshot: {
    all: (roadmapId: number, viewId: number) =>
      ['roadmap', roadmapId, 'view', viewId, 'snapshot'] as const,
    items: (roadmapId: number, viewId: number) =>
      ['roadmap', roadmapId, 'view', viewId, 'snapshot', 'items'] as const,
    schedules: (roadmapId: number, viewId: number) =>
      ['roadmap', roadmapId, 'view', viewId, 'snapshot', 'schedules'] as const,
  },
  visualization: {
    all: (viewId: number) => ['visualization', 'list', viewId] as const,
    detail: (viewId: number, visualizationId: number) =>
      ['visualization', 'detail', viewId, visualizationId] as const,
    byType: (viewId: number, type: string) => ['visualization', 'byType', viewId, type] as const,
  },
  swimlaneLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['swimlane-layout', viewId, visualizationId] as const,
    headerConfig: (
      viewId: number,
      visualizationId: number,
      headerFieldId: string,
      parentFieldId?: string | null,
      parentHeaderId?: string | null,
    ) =>
      [
        'swimlane-layout',
        'header-config',
        viewId,
        visualizationId,
        headerFieldId,
        parentFieldId ?? null,
        parentHeaderId ?? null,
      ] as const,
  },
  tableLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['table-layout', viewId, visualizationId] as const,
  },
  itemRanks: {
    detail: (viewId: number, visualizationId: number) =>
      ['item-ranks', viewId, visualizationId] as const,
  },
  timelineLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['timeline-layout', viewId, visualizationId] as const,
    headerConfig: ({
      viewId,
      visualizationId,
      headerFieldId,
      parentFieldId,
      parentHeaderId,
    }: {
      viewId: number;
      visualizationId: number;
      headerFieldId: string;
      parentFieldId?: string | null;
      parentHeaderId?: string | null;
    }) =>
      [
        'timeline-layout',
        'header-config',
        viewId,
        visualizationId,
        headerFieldId,
        parentFieldId,
        parentHeaderId,
      ] as const,
  },
  publishedVisualization: {
    detail: (viewId: number, visualizationId: number) =>
      ['published-visualization', viewId, visualizationId] as const,
  },
};
